<div *ngIf="anyShown && !hideTopLevelName" class="object-block cursor-pointer" (click)="isExpanded = !isExpanded">
  <span class="full-name">{{getNameForDisplay()}}</span>
</div>
<div *ngIf="anyShown && (hideTopLevelName || isExpanded)" [class.indented]="!hideTopLevelName">
  <div *ngFor="let child of shownChildren">
    <div *ngIf="child.isPrimitive; else objectChild" class="primitive-block">
      <span class="label">{{propertyKeyToDisplayLabel(child.key)}}</span>
      <span class="value">{{child.value}}</span>
    </div>
    <ng-template #objectChild>
      <div class="cursor-pointer">
        <order-object-viewer [object]="child.value" [customName]="isArray ? '' : child.key" [isArrayItem]="isArray" [filterText]="filterText" [showFriendly]="showFriendly" [propertyDisplayConfig]="getChildPropertyDisplayConfig(child.key)"></order-object-viewer>
      </div>
    </ng-template>
  </div>
</div>